/**
 * isScrolledInput / isScrolled solo se actualizaban en el evento scroll.
 * Al cambiar de ruta (p. ej. checkout → home en top=0), no hay evento scroll
 * y el store conservaba el valor de la página anterior.
 */
export default defineNuxtPlugin(() => {
  const router = useRouter()
  const scrollStore = useScrollStore()

  const sync = () => {
    nextTick(() => {
      requestAnimationFrame(() => {
        scrollStore.checkScrollInput()
      })
    })
  }

  router.afterEach(() => {
    sync()
  })
})
